import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomStorageService } from '../custom-storage/custom-storage.service';
import {
  CONSUMPTION_LIMIT
} from '../../shared/constants/urls';
@Injectable({
  providedIn: 'root'
})
export class ConsumptionLimitService {

  constructor(private httpclient: HttpClient,
    private readonly storageService: CustomStorageService) { }

  getHeader() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      authorization: 'bearer ' + this.storageService.getToken()
    });
    return headers;
  }

  getConsumptionById(id) {
    return this.httpclient.get(CONSUMPTION_LIMIT + id, { headers: this.getHeader() });
  }

  createConsumption(body) {
    return this.httpclient.post(CONSUMPTION_LIMIT, body, { headers: this.getHeader() });
  }

  postConsumption(idEnterprise) {
    return this.httpclient.put(CONSUMPTION_LIMIT + 'badges/' +  idEnterprise, { headers: this.getHeader() });
  }

  createConsumptionBadge(body, badgeId, enterpriseId) {
    return this.httpclient.post(CONSUMPTION_LIMIT + 'badges' + '?badgeId=' + badgeId + '&enterpriseId=' + enterpriseId
     , body, { headers: this.getHeader() });
  }

  putConsumption(body , id) {
    return this.httpclient.put(CONSUMPTION_LIMIT + id, body, { headers: this.getHeader() });
  }
}
